// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1YI6W","paramInput":"JobSimulator_paramInput__25b1K","input":"JobSimulator_input__13xRa"};